import cx from 'classnames';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import Icon from 'components/Icon';
import { ButtonV3 } from 'components/ComponentV2';
import { PAGE_ROUTES } from 'lib/page-routes';

import styles from './AISearchSuggestionBanner.module.scss';

type AISearchSuggestionBannerProps = {
  className?: string;
  contentClassName?: string;
  onClose: () => void;
};

export const AISearchSuggestionBanner: React.FC<AISearchSuggestionBannerProps> =
  ({ className, contentClassName, onClose }) => {
    const [t] = useTranslation('common');

    return (
      <section className={cx(styles.container, className)}>
        <Icon
          iconName="icon_magic-wand"
          className={styles.icon}
          size="xmediumplus"
        />
        <div className={cx(styles.content, contentClassName)}>
          <header className={styles.header}>
            <h3 className={styles.title}>{t('ai-search-banner.title')}</h3>
            <p className={styles.description}>
              {t('ai-search-banner.description')}
            </p>
          </header>
          <footer className={styles.actions}>
            <Link href={PAGE_ROUTES.AI_SEARCH}>
              <ButtonV3 color="primary">
                {t('ai-search-banner.search-with-ai')}
              </ButtonV3>
            </Link>
            <ButtonV3 color="secondary" onClick={onClose}>
              {t('ai-search-banner.try-later')}
            </ButtonV3>
          </footer>
        </div>
      </section>
    );
  };
